import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { ReactComponent as AddBlock } from '../../images/add-block.svg';

export const AddBlockIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} component={AddBlock} />
);

export default AddBlockIcon;
